import React, { Component } from 'react';
import './ClassSection.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AgeWiseActions from '../../Actions/AgeWiseSearch';
import * as sharedActions from '../../Actions/sharedActions';
import DropDownComponent from './DropDownComponent';
class AgeWiseSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dummy: [],
			sessions: []
		};
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if (
			prevState.dummy !== nextProps.selectStudent ||
			prevState.sessions !== nextProps.selectSession
		) {
			return {
				dummy: nextProps.selectStudent,
				sessions: nextProps.selectSession
			};
		}
		return null;
	}
	componentDidMount() {
		this.props.sharedActions
			.gAllData('/api/Session', this.props.AgeWiseActions.getSessionsForAgeWise)
			.then(success => {})
			.catch(error => {});
		this.props.sharedActions
			.gAllData(
				'/api/ClassSection',
				this.props.AgeWiseActions.getStudentForAgeWise
			)
			.then(success => {})
			.catch(error => {});
	}
	render() {
		const { classList } = this.state.dummy;
		const { section } = this.state.dummy;
		const { session } = this.state.sessions;
		console.log('Sessions', session);
		return (
			<div>
				<div style={{ justifyContent: 'center', textAlign: 'center' }}>
					<DropDownComponent
						data={classList}
						Document={section}
						session={session}
					/>
				</div>
			</div>
		);
	}
}
function mapDispatchToProps(dispatch) {
	return {
		sharedActions: bindActionCreators(sharedActions, dispatch),
		AgeWiseActions: bindActionCreators(AgeWiseActions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		userData: state.setUserReducer.users,
		selectStudent: state.setAgeWiseSearchReducer.selectStudent,
		selectSession: state.setAgeWiseSearchReducer.selectSession
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AgeWiseSearch);
